/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CreateContactListRequestContactListFromJSON, CreateContactListRequestContactListToJSON } from './CreateContactListRequestContactList';
export function UpdateContactListRequestFromJSON(json) {
    return UpdateContactListRequestFromJSONTyped(json, false);
}
export function UpdateContactListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactList: !exists(json, 'contact_list')
            ? undefined
            : CreateContactListRequestContactListFromJSON(json['contact_list'])
    };
}
export function UpdateContactListRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_list: CreateContactListRequestContactListToJSON(value.contactList)
    };
}
